import { useRouteMatch } from "react-router-dom";

export const IsRouteMatch = ({ route }) => {
  const currentRouteMatch = useRouteMatch();
  const verifiedSection = currentRouteMatch?.path === route;
  return verifiedSection;
};
